/* eslint-disable react/react-in-jsx-scope */
import AuthenticationRequired from "@/components/AuthenticationRequired";
import ImpersonationHandler from "@/auth/components/ImpersonationHandler";
import NotFoundPage from "@/components/errors/404";
import ErrorBoundary from "@/components/errors/ErrorBoundary";
import Layout from "@/components/layout/Layout";
import LayoutDashboard from "@/components/layout/LayoutDashboard";
import Auth from "@/pages/auth/Auth";
import EmailVerification from "@/pages/auth/EmailVerification";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import Certificats from "@/pages/Certificats";
import Contributions from "@/pages/Contributions";
import DashboardFinanceur from "@/pages/DashboardFinanceur";
import Document from "@/pages/Document";
import Documents from "@/pages/Documents";
import Error from "@/pages/Error";
import Home from "@/pages/Home";
import Program from "@/pages/Program";
import Project from "@/pages/Project";
import ProjectOwner from "@/pages/projectOwner";
import { Route, Routes } from "react-router-dom";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/admin-impersonation" element={<ImpersonationHandler />} />

      <Route
        path="/"
        element={
          <ErrorBoundary>
            <Home />
          </ErrorBoundary>
        }
      />

      <Route
        path="/login"
        element={
          <ErrorBoundary>
            <Layout>
              <Auth />
            </Layout>
          </ErrorBoundary>
        }
      />
      <Route
        path="/register/verify"
        element={
          <ErrorBoundary>
            <Layout>
              <EmailVerification />
            </Layout>
          </ErrorBoundary>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <ErrorBoundary>
            <Layout>
              <ForgotPassword />
            </Layout>
          </ErrorBoundary>
        }
      />
      <Route
        path="/reset-password"
        element={
          <ErrorBoundary>
            <Layout>
              <ResetPassword />
            </Layout>
          </ErrorBoundary>
        }
      />
      <Route
        path="/error"
        element={
          <ErrorBoundary>
            <Error />
          </ErrorBoundary>
        }
      />

      {/* Route : /dashboard */}
      <Route path=":firstname">
        <Route
          index
          element={
            <ErrorBoundary>
              <AuthenticationRequired redirect="/">
                <LayoutDashboard>
                  <DashboardFinanceur />
                </LayoutDashboard>
              </AuthenticationRequired>
            </ErrorBoundary>
          }
        />
        <Route
          path="pp"
          element={
            <ErrorBoundary>
              <AuthenticationRequired redirect="/">
                <LayoutDashboard>
                  <ProjectOwner />
                </LayoutDashboard>
              </AuthenticationRequired>
            </ErrorBoundary>
          }
        />
        <Route
          path="pp/:idPp"
          element={
            <ErrorBoundary>
              <AuthenticationRequired redirect="/">
                <LayoutDashboard>
                  <ProjectOwner />
                </LayoutDashboard>
              </AuthenticationRequired>
            </ErrorBoundary>
          }
        />
        <Route
          path="mes-documents"
          element={
            <ErrorBoundary>
              <AuthenticationRequired redirect="/">
                <LayoutDashboard>
                  <Documents />
                </LayoutDashboard>
              </AuthenticationRequired>
            </ErrorBoundary>
          }
        />
        <Route
          path="mes-certificats"
          element={
            <ErrorBoundary>
              <AuthenticationRequired redirect="/">
                <LayoutDashboard>
                  <Certificats />
                </LayoutDashboard>
              </AuthenticationRequired>
            </ErrorBoundary>
          }
        />
        <Route
          path="suivi-contribution"
          element={
            <ErrorBoundary>
              <AuthenticationRequired redirect="/">
                <LayoutDashboard>
                  <Contributions />
                </LayoutDashboard>
              </AuthenticationRequired>
            </ErrorBoundary>
          }
        />
        <Route
          path="mes-documents/:idPp"
          element={
            <ErrorBoundary>
              <AuthenticationRequired redirect="/">
                <LayoutDashboard>
                  <Document />
                </LayoutDashboard>
              </AuthenticationRequired>
            </ErrorBoundary>
          }
        />
        <Route
          path="program"
          element={
            <ErrorBoundary>
              <AuthenticationRequired redirect="/">
                <LayoutDashboard>
                  <ProjectOwner />
                </LayoutDashboard>
              </AuthenticationRequired>
            </ErrorBoundary>
          }
        />
        <Route
          path="program/:programId"
          element={
            <ErrorBoundary>
              <AuthenticationRequired redirect="/">
                <LayoutDashboard>
                  <Program />
                </LayoutDashboard>
              </AuthenticationRequired>
            </ErrorBoundary>
          }
        />
        <Route
          path="project/:projectId"
          element={
            <ErrorBoundary>
              <AuthenticationRequired redirect="/">
                <LayoutDashboard>
                  <Project />
                </LayoutDashboard>
              </AuthenticationRequired>
            </ErrorBoundary>
          }
        />
      </Route>

      <Route
        path="*"
        element={
          <ErrorBoundary>
            <NotFoundPage isPageChildren={false} />
          </ErrorBoundary>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
